import { render, staticRenderFns } from "./unassigned.vue?vue&type=template&id=e47102e4&scoped=true&"
import script from "./unassigned.vue?vue&type=script&lang=js&"
export * from "./unassigned.vue?vue&type=script&lang=js&"
import style0 from "./unassigned.vue?vue&type=style&index=0&id=e47102e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47102e4",
  null
  
)

export default component.exports